(function () {
    console.log("bundle-remove loaded");

  function findRemoveAnchor(target) {
    // Dawn: <cart-remove-button> içindeki <a href="/cart/change?...quantity=0">
    const anchor = target.closest('cart-remove-button a[href*="/cart/change"]');
    if (anchor) return anchor;

    // fallback (bazı temalarda button olabilir)
    return target.closest('a[href*="/cart/change"], button[name="remove"]');
  }

  function findBundleIdFromDOM(target) {
    // Önce bundle-parent wrapper'ını ara
    const parentWrap =
      target.closest('.bundle-parent[data-bundle-id]') ||
      target.closest('[data-bundle-parent="true"][data-bundle-id]');

    if (parentWrap) return parentWrap.getAttribute("data-bundle-id");

    // Sonra bundle-group'a bak
    const group = target.closest('.bundle-group[data-bundle-id]');
    if (group) return group.getAttribute("data-bundle-id");

    return null;
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("cart.js okunamadı");
    return res.json();
  }

  function getBundleIdFromCartItem(item) {
    const p = item.properties || {};
    return p._bundle_id || p["_bundle_id"] || null;
  }

  async function removeBundle(bundleId) {
    const cart = await fetchCart();

    const itemsToRemove = cart.items.filter(
      (it) => String(getBundleIdFromCartItem(it)) === String(bundleId)
    );

    console.log("[bundle-remove] bundleId:", bundleId);
    console.log(
      "[bundle-remove] matched items:",
      itemsToRemove.map((x) => ({ key: x.key, title: x.title, props: x.properties }))
    );

    if (!itemsToRemove.length) return false;

    // ✅ tek request ile hepsini 0'la
    const updates = {};
    itemsToRemove.forEach((it) => (updates[it.key] = 0));

    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates })
    });

    if (!res.ok) {
      const txt = await res.text();
      console.error("[bundle-remove] update failed:", txt);
      throw new Error(txt || "update.js failed");
    }

    return true;
  }

  function refreshCartUI() {
    window.location.reload();
  }

  // ✅ capture phase: theme JS'den önce yakala
  document.addEventListener(
    "click",
    async (e) => {
      const removeAnchor = findRemoveAnchor(e.target);
      if (!removeAnchor) return;

      // bundle parent satırında mı tıklandı?
      const bundleId = findBundleIdFromDOM(removeAnchor);
      if (!bundleId) return; // bundle değilse default devam

      // bundle ise default kaldırmayı engelle
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      try {
        const ok = await removeBundle(bundleId);
        if (ok) {
          refreshCartUI();
          return;
        }

        // fallback: normal remove
        window.location.href = removeAnchor.getAttribute("href") || "/cart";
      } catch (err) {
        console.error("[bundle-remove] failed:", err);
        window.location.href = "/cart";
      }
    },
    true
  );
})();
